// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__3thFz","selected":"Chip_selected__3zaLi"};